import { Note } from '@usf/alert-types';
import { MERCH_FEATURE } from '@usf/ngrx-product';
import { ProductDetailService } from './../../../product-detail/services/product-detail.service';
import { Component, Input } from '@angular/core';
import { UsfProductCardModeEnum } from '../../../shared/constants/usf-product-card-mode.enum';
import { PanAppState } from '@panamax/app-state';
import { Product } from '../../../shared/models/product.model';
import { ItemTypes } from '../../../lists/shared/list-detail-management/model/list-detail-management-view.model';
import { Customer } from '@usf/customer-types';
import {
  EllipsisClickData,
  ProductClickData,
} from '../../../shared/models/usf-product-card.model';
import { TmNoteProductCardService } from '../../../shared/services/product-card/tm-note-product-card.service';

@Component({
  selector: 'app-tm-note-product-card',
  templateUrl: './tm-note-product-card.component.html',
  styleUrls: ['./tm-note-product-card.component.scss'],
})
export class TmNoteProductCardComponent {
  @Input() isTouchExperience: boolean;
  @Input() product: Product;
  @Input() customer: Customer;
  @Input() pageType: string;
  @Input() note: Note;
  @Input() lnkSrc: string;
  @Input() index: number;

  mode: UsfProductCardModeEnum = UsfProductCardModeEnum.tmNoteDetails;
  itemTypes = ItemTypes;

  constructor(
    readonly panAppState: PanAppState,
    private productDetailService: ProductDetailService,
    private tmNoteProductCardService: TmNoteProductCardService,
  ) {}

  changeQuantityHandler(event: any) {
    this.productDetailService.trackRelatedProductChangeQuantity(
      event.quantityUpdate,
      event.product,
      MERCH_FEATURE.tmNotesName,
      0,
      this.note.noteId,
    );
  }

  async routeToPDP(productClickData: ProductClickData) {
    this.tmNoteProductCardService.routeToPDP(
      productClickData.productNumber,
      productClickData.isQuickView,
    );
  }

  async openProductStatus(ellipsisClickData: EllipsisClickData) {
    this.tmNoteProductCardService.showProductStatuses(ellipsisClickData);
  }
}
